import { Card, Container } from "../../../components";
import OrderAlarm from "./orderAlarm";
import AlarmList from "./alarmList";
import Details from "./details";
import React from "react";

const View = ({ hasAlarm = true, ...props }) => {
  return (
    <Container>
      <Details hasAlarm={hasAlarm} {...props} />
      <Card>
        {hasAlarm ? <AlarmList {...props} /> : <OrderAlarm {...props} />}
      </Card>
    </Container>
  );
};

export default View;
